module.exports = __webpack_public_path__ + "media/application/images/external-services/squarespace-logo-25252c208ec1fb4f9e4fa6292d4c2d3d.svg";